<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n';
    
    import FloatingButton from '../FloatingButton.svelte';
    import DatePicker from '../DatePicker.svelte';
    import {sectionMeasurementsDateTimesStore} from "../../stores/section-measurement-date-times.store";
    import type {DashboardDateRange} from "../../types/filters/dashboard-date-range.type";

    export let resetDates: boolean = false;
    
    const dispatch = createEventDispatcher();
    let label: string = '';

    const handleSelectedDate = (e: CustomEvent<Date[]>) => {
        const startDateSet = e.detail !== null && e.detail?.length > 0;
        const endDateSet = e.detail !== null && e.detail?.length > 1;
        label = startDateSet 
            ? `${e.detail[0]?.toLocaleDateString()} ${endDateSet ? '- ' + e.detail[1]?.toLocaleDateString() : ''}`
            : '';
        
        const filter: DashboardDateRange = {
            startDate: e.detail[0],
            endDate: e.detail[1]
        }
        dispatch('change', filter);
    };
</script>

<FloatingButton label={label || $_('pages.dashboard.SELECT_DATE')} active={label.length > 0} activeIcon="check" inactiveIcon="">
    <DatePicker bind:resetDates enabledTimestamps={$sectionMeasurementsDateTimesStore} range on:selected={(e) => handleSelectedDate(e)} />
</FloatingButton>

<style>
</style>
